import { BillingCardFields } from '@pages/BindQuote/BillingCard';

export function getInitialBillingValues({
  billingCardFields,
  policyQuoteItem,
}: {
  billingCardFields: BillingCardFields;
  policyQuoteItem: any;
}): Record<string, any> {
  return {
    street: {
      ...billingCardFields.street,
      value: policyQuoteItem?.attributeTypes.BillingStreet?.attribute?.value || '',
    },
    street2: {
      ...billingCardFields.street2,
      value: policyQuoteItem?.attributeTypes.BillingStreet2?.attribute?.value || '',
    },
    city: {
      ...billingCardFields.city,
      value: policyQuoteItem?.attributeTypes.BillingCity?.attribute?.value || '',
    },
    state: {
      ...billingCardFields.state,
      value: policyQuoteItem?.attributeTypes.BillingState?.attribute?.value || '',
    },
    zip: {
      ...billingCardFields.zip,
      value: policyQuoteItem?.attributeTypes.BillingZip?.attribute?.value || '',
    },
    phone: {
      ...billingCardFields.phone,
      value: policyQuoteItem?.attributeTypes.BillingPhone?.attribute?.value || '',
    },
    primaryContact: {
      ...billingCardFields.primaryContact,
      value: policyQuoteItem?.attributeTypes.BillingContact?.attribute?.value || '',
    },
    emailAddress: {
      ...billingCardFields.emailAddress,
      value: policyQuoteItem?.attributeTypes.BillingEmail?.attribute?.value || '',
    },
    billPlan: {
      ...billingCardFields.billPlan,
      value: policyQuoteItem?.attributeTypes.PaymentPlan?.attribute?.value || '',
    },
    endorsementPaymentOption: {
      ...billingCardFields.endorsementPaymentOption,
      value: policyQuoteItem?.attributeTypes.EndorsementPaymentOption?.attribute?.value || '',
    },
    binderInd: {
      ...billingCardFields.binderInd,
      value: policyQuoteItem?.attributeTypes.BinderInd?.attribute?.value ?? false,
    },
    bindingConditionsDetails: {
      ...billingCardFields.bindingConditionsDetails,
      value: policyQuoteItem?.attributeTypes.BindingConditionsDetails?.attribute?.value ?? '',
    },
    billingMethod: {
      ...billingCardFields.billingMethod,
      value: policyQuoteItem?.attributeTypes.BillingMethod?.attribute?.value ?? '',
    },
  };
}
